module.exports = __webpack_public_path__ + "static/media/preApprovedPig.b0a96119.svg";